import React from 'react';
import { Link } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { FEATURE_CONFIG, FeatureConfig } from '../features.config';

export const PortalPage: React.FC = () => {
  const { accounts } = useMsal();
  const groups: string[] =
    (accounts[0]?.idTokenClaims as Record<string, unknown>)?.groups as string[] ?? [];

  const accessible = FEATURE_CONFIG.filter(
    (f) => f.groupId && groups.includes(f.groupId)
  );

  return (
    <div className="min-h-screen bg-surface">
      <nav className="bg-surface-alt border-b border-border-default">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-14 items-center">
            <span className="text-lg font-semibold text-primary">Corp Admin</span>
          </div>
        </div>
      </nav>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-bold text-primary mb-6">Your Tools</h1>
        {accessible.length === 0 ? (
          <p className="text-muted">
            No tools are available for your account. Contact your administrator to request access.
          </p>
        ) : (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {accessible.map((feature: FeatureConfig) => (
              <Link
                key={feature.key}
                to={feature.path}
                className="block rounded-lg border border-border-default bg-surface-alt p-6 shadow-sm hover:shadow-md transition-shadow"
              >
                <h2 className="text-base font-semibold text-primary">{feature.name}</h2>
                <p className="mt-1 text-sm text-muted">{feature.description}</p>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};
